module.exports = __webpack_public_path__ + "media/images/401playlogo-7fc2cf6b089f7740a698ee72bf1d5172.png";